/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getSupportArticleForTransaction} from '../api'

 export const useQueryGetSupportArticleForTransaction = createReactQueryHook('getSupportArticleForTransaction', getSupportArticleForTransaction)
